import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import JSForm from '../../Form';

const RelaunchForm = ({ step, onClose, handleRelaunch }) => {
  const { t } = useTranslation();

  const customFormats = {
    // eslint-disable-next-line no-useless-escape
    'phone-us': /^\+\d{1,40}$/,
    // eslint-disable-next-line no-useless-escape
    'customEmail': /^\w+([\.-]?[/]?\w+)*-?@\w+([\.-]?\w+)*(\.\w{2,65})+$/
  };

  const schema = {
    type: 'object',
    title: t('relaunchForm:title'),
    description: t('relaunchForm:description'),
    required: [],
    properties: {}
  };

  Object.keys(step)
    .filter(key => ['emails', 'mobiles'].includes(key))
    .reduce((schema, current) => {
      if (step.mobiles != null) {
        schema.properties[current] = {
          type: 'array',
          title: t('relaunchForm:mobiles'),
          items: {
            type: 'string',
            format: 'phone'
          }
        };
      }
      if (step.emails != null) {
        schema.properties[current] = {
          type: 'array',
          title: t('relaunchForm:emails'),
          items: {
            type: 'string',
            format: 'customEmail'
          }
        };
      }

      schema.required.push(current);

      return schema;
    }, schema);

  const handleClose = () => {
    onClose(false);
  };

  const onSubmit = ({ formData }) => {
    handleRelaunch({ updatedStep: formData });
    handleClose();
  };

  const uischema = {
    emails: {
      'ui:options': {
        'addable': false,
        'orderable': false,
        'removable': false
      }
    },
    mobiles: {
      'ui:options': {
        'addable': false,
        'orderable': false,
        'removable': false
      }
    }

  };

  return (
    <Dialog open={!!step} onClose={handleClose} aria-labelledby='form-dialog-title' maxWidth='md' fullWidth>
      <DialogContent>
        <JSForm
          schema={schema}
          uiSchema={uischema}
          formData={step}
          onSubmit={onSubmit}
          customFormats={customFormats}
        >
          <DialogActions>
            <Button variant='outlined' color='primary' onClick={handleClose}>
              {t('alertDialog:cancel')}
            </Button>
            <Button variant='contained' type='submit' color='primary'>
              {t('alertDialog:accept')}
            </Button>
          </DialogActions>
        </JSForm>
      </DialogContent>
    </Dialog>
  );
};

RelaunchForm.propTypes = {
  flow: PropTypes.object.isRequired,
  step: PropTypes.object.isRequired,
  flowTemplates: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRelaunch: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {
    flowTemplates: state.config.flows
  };
};

export default connect(mapStateToProps)(RelaunchForm);
